import {Navigate, Route, Routes} from 'react-router-dom';
import AdminLayout from 'layouts/admin';
import AuthLayout from 'layouts/auth';
import UseLoginStore from './stores/LoginStore';
import ProtectedRoute from './views/ProtectedRoute';
import NoMatch from './views/NoMatch';
import {useEffect} from 'react';
import Spinner from './components/spinner';
import './assets/css/App.css';

const App = () => {
  const {loggedIn, refresh, loading} = UseLoginStore((store) => {
    return {
      loggedIn: store.loggedIn,
      refresh: store.refresh,
      loading: store.loading,
    };
  });

  useEffect(() => {
    (async () => {
      try{
        await refresh();
      }catch(err) {}
    })();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route
        path="admin/*"
        element={
          <ProtectedRoute isAllowed={loggedIn}>
            <AdminLayout />
          </ProtectedRoute>
        }
      />
      <Route index element={<Navigate to="/admin/default" replace />} />
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
};

export default App;
